import { FORM } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchUpdateForm = async (formId, submittedBy) => {
  const response = await ApiRequestInterceptor(
    `${FORM.updateForm}/${formId}`,
    "PUT",
    { submittedBy }
  );

  if (response.code === 200) return response;

  const errorMessage = response?.data?.error || "Error al actualizar formulario";
  throw new Error(errorMessage);
};
